var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClockDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 258,
    x2: 512,
    y2: 258,
    gradientTransform: "matrix(1 0 0 -1 0 514)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00F2FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    style: {
      stopColor: "#03EFFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    style: {
      stopColor: "#24D2FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554,
    style: {
      stopColor: "#3CBDFE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796,
    style: {
      stopColor: "#4AB0FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4FACFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M512,256c0,50.531-14.998,99.674-43.373,142.116c-3.856,5.768-10.191,8.886-16.646,8.886 c-3.82,0-7.683-1.092-11.098-3.375c-9.182-6.139-11.649-18.56-5.511-27.742C459.335,340.044,472,298.589,472,256 c0-112.364-86.232-204.963-196-215.082V100c0,11.046-8.954,20-20,20s-20-8.954-20-20V20c0-11.046,8.954-20,20-20 c68.38,0,132.667,26.628,181.02,74.98C485.371,123.333,512,187.62,512,256z M367.737,440.894C334.143,461.244,295.505,472,256,472 c-119.103,0-216-96.897-216-216c0-33.057,7.265-64.77,21.593-94.26c4.827-9.935,0.686-21.902-9.249-26.729 c-9.936-4.827-21.902-0.685-26.729,9.249C8.618,179.242,0,216.837,0,256c0,68.38,26.629,132.667,74.98,181.02 C123.333,485.372,187.62,512,256,512c46.812,0,92.616-12.757,132.462-36.893c9.447-5.723,12.467-18.021,6.744-27.468 C389.482,438.19,377.186,435.171,367.737,440.894z M70.527,98.343c-5.471-7.945-4.491-18.664,2.33-25.485s17.54-7.802,25.485-2.33 C128.93,91.59,282.328,197.475,298.427,213.574c23.394,23.394,23.394,61.458,0,84.853c-11.697,11.697-27.063,17.545-42.427,17.545 s-30.729-5.849-42.427-17.545C197.475,282.328,91.59,128.93,70.527,98.343z M166.799,166.798 c37.589,53.581,68.854,97.067,75.063,103.347c7.793,7.794,20.481,7.795,28.28-0.003c7.798-7.797,7.799-20.483,0.004-28.281 C263.864,235.652,220.379,204.388,166.799,166.798z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockDark);
export default __webpack_public_path__ + "static/media/ClockDark.fa60d674.svg";
export { ForwardRef as ReactComponent };